export default __webpack_public_path__ + "static/media/OpenSans-Bold.2e83ce6b.ttf";